import {matchedBrands,collectionUrl} from './brand-range-match.js';
export function installBrandRangeLinks(doc=document,win=window){
 if(doc.documentElement.dataset.tbBrandRangeInstalled)return;doc.documentElement.dataset.tbBrandRangeInstalled='true';
 const config=doc.querySelector('[data-tb-brand-range-config]');const root=config?.dataset.root||'/';
 let lastInput=null,scheduled=false;
 const isSearchInput=e=>e?.matches?.('input[name="q"],.cloud-search-mobile__input,[aria-controls="cloud-search-results"]');
 function draw(target,query,placement){
  const brands=matchedBrands(query);let nav=placement==='append'?target.querySelector(':scope > [data-tb-brand-range]'):target.nextElementSibling?.matches('[data-tb-brand-range]')?target.nextElementSibling:null;
  if(!brands.length){nav?.remove();return;}
  const signature=brands.map(b=>b.key).join('|');
  if(nav?.dataset.signature===signature)return;
  if(!nav){nav=doc.createElement('nav');nav.dataset.tbBrandRange='';nav.className='tb-brand-range';nav.setAttribute('aria-label','Browse the full brand range');if(placement==='append')target.append(nav);else target.after(nav);}
  nav.replaceChildren();nav.dataset.signature=signature;
  for(const b of brands){const a=doc.createElement('a');a.href=collectionUrl(b,root);a.textContent='See the full '+b.label+' range';a.className='tb-brand-range__link link';nav.append(a);}
 }
 function update(){
  scheduled=false;const instant=doc.querySelector('#cloud-search-results');
  const active=doc.activeElement;
  const input=isSearchInput(active)?active:lastInput?.isConnected?lastInput:doc.querySelector('input.search-bar__input[name="q"][aria-controls="cloud-search-results"]');
  if(instant)draw(instant,input?.value||'','append');
  if(/\/(?:a\/)?search\/?$/.test(win.location.pathname)){
   const area=doc.querySelector('#shopify-section-main .collection__dynamic-part');
   if(area){const list=area.querySelector(':scope > .product-list.product-list--collection');
    // Search app may replace its grid on pagination/filter changes.
    for(const stale of area.querySelectorAll(':scope > [data-tb-brand-range]')){
     if(list&&stale.previousElementSibling!==list)stale.remove();
    }
    const query=new URL(win.location.href).searchParams.get('q')||'';
    draw(list||area,query,list?'after':'append');
   }
  }
 }
 function schedule(){if(!scheduled){scheduled=true;win.requestAnimationFrame(update);}}
 doc.addEventListener('input',e=>{if(isSearchInput(e.target)){lastInput=e.target;schedule();}});
 doc.addEventListener('focusin',e=>{if(isSearchInput(e.target)){lastInput=e.target;schedule();}});
 doc.addEventListener('click',e=>{if(e.target.closest?.('[data-action="clear-input"],.cloud-search-mobile__cancel'))schedule();});
 win.addEventListener('popstate',schedule);
 const observer=new win.MutationObserver(schedule);observer.observe(doc.body,{childList:true,subtree:true});schedule();
 return {update,disconnect:()=>observer.disconnect()};
}
if(typeof document!=='undefined')installBrandRangeLinks();
